import { isEqual } from "lodash";

import type { StorageKey } from "../../enums";
import type { IPageSchema, TValidFinalSchema } from "../../models";
import {
  getStoredFinalSchemaMap,
  setStoredFinalSchemaMap,
} from "./final-schema.storage.helpers.methods";
import type { TPage } from "./final-schema.storage.helpers.models";
import { localStorageHelpers } from "./storage.helpers";

export const getLastFinalSchemaLocalStore = (
  companyId: number,
  page: TPage,
): IPageSchema | null => {
  const storedFinalSchemaMap = getStoredFinalSchemaMap(companyId);
  return storedFinalSchemaMap.get(page) ?? null;
};

interface ISetLastActiveViewIdArguments {
  companyId: number;
  page: TPage;
  finalSchema: TValidFinalSchema;
}

export const setFinalSchemaLocalStore = ({
  companyId,
  page,
  finalSchema,
}: ISetLastActiveViewIdArguments): void => {
  const storedFinalSchemaMap = getStoredFinalSchemaMap(companyId);
  storedFinalSchemaMap.set(page, finalSchema);

  setStoredFinalSchemaMap(companyId, storedFinalSchemaMap);
};

interface IUpdateLastActiveViewIdArguments {
  companyId: number;
  page: TPage;
  finalSchema: Partial<TValidFinalSchema>;
}

export const updateFinalSchemaLocalStore = ({
  companyId,
  page,
  finalSchema,
}: IUpdateLastActiveViewIdArguments): void => {
  const storedFinalSchemaMap = getStoredFinalSchemaMap(companyId);
  const storedPageSchema = storedFinalSchemaMap.get(page);

  const finalPageSchemaComposed: TValidFinalSchema = {
    filtersCriteria:
      finalSchema.filtersCriteria ?? storedPageSchema?.filtersCriteria ?? {},
    filtersSchema:
      finalSchema.filtersSchema ?? storedPageSchema?.filtersSchema ?? {},
    columnsGrouping:
      finalSchema.columnsGrouping ?? storedPageSchema?.columnsGrouping ?? [],
    columnsSorting:
      finalSchema.columnsSorting ?? storedPageSchema?.columnsSorting ?? [],
    columnsVisibility:
      finalSchema.columnsVisibility ??
      storedPageSchema?.columnsVisibility ??
      {},
    columnsOrder:
      finalSchema.columnsOrder ?? storedPageSchema?.columnsOrder ?? [],
    columnsSizing:
      finalSchema.columnsSizing ?? storedPageSchema?.columnsSizing ?? {},
  };

  if (!isEqual(storedPageSchema, finalPageSchemaComposed)) {
    storedFinalSchemaMap.set(page, finalPageSchemaComposed);
    setStoredFinalSchemaMap(companyId, storedFinalSchemaMap);
  }
};

export const clearLastFinalSchemaLocalStore = (
  companyId: number,
  page: TPage,
): void => {
  const storedFinalSchemaMap = getStoredFinalSchemaMap(companyId);
  storedFinalSchemaMap.delete(page);

  setStoredFinalSchemaMap(companyId, storedFinalSchemaMap);
};

export const clearAllLastFinalSchemaLocalStore = (): void => {
  Object.keys(localStorage).forEach(key => {
    if (key.endsWith("lastFinalSchema")) {
      localStorageHelpers.removeItem(key as StorageKey);
    }
  });
};
